// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-fwwgl-spgl-Video-main_right_content-22hBJ","table":"components-fwwgl-spgl-Video-table-9DEF8","button":"components-fwwgl-spgl-Video-button-1p7E7","pBtn":"components-fwwgl-spgl-Video-pBtn-3iAuJ","active":"components-fwwgl-spgl-Video-active-3qUCl","line":"components-fwwgl-spgl-Video-line-3f-i0","labelStyle":"components-fwwgl-spgl-Video-labelStyle-2foyB","inputSelect":"components-fwwgl-spgl-Video-inputSelect-12A_U"};


//////////////////
// WEBPACK FOOTER
// ./components/fwwgl/spgl/Video.css
// module id = 813
// module chunks = 0